/**
 * Router setup
 */
import Vue  from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
import router from 'router';

export default router;